// WhatsApp Click-to-Chat helper with built-in source tracking.
//
// Every WhatsApp link on the site is built through `waLink({ source, message })`
// so the prefilled chat message includes a tag like:
//   [src: model_s650 · /models/s650]
// When a lead messages Bhumi Equipments, the owner instantly sees which page
// or model on the website triggered the conversation — turning WhatsApp into
// a lightweight, zero-config CRM.

const WA_NUMBER = "919167632596";

/**
 * Build a tracked wa.me URL.
 * @param {object} opts
 * @param {string} opts.source       Stable id e.g. "model_s650", "floating", "footer"
 * @param {string} [opts.message]    User-facing prefix (we'll append the source tag)
 * @param {object} [opts.extra]      Extra k/v pairs surfaced in the tag e.g. {qty: 2}
 * @returns {string} https://wa.me/<num>?text=<encoded>
 */
export function waLink({ source = "site", message, extra = {} } = {}) {
  const path =
    typeof window !== "undefined" ? window.location.pathname + window.location.search : "/";
  const extras = Object.entries(extra)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${k}=${v}`)
    .join(" · ");
  const tag = `[src: ${source} · ${path}${extras ? " · " + extras : ""}]`;
  const body = (message || "Hi Bhumi Equipments, I'd like to connect.").trim();
  const text = `${body}\n\n${tag}`;
  return `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;
}

export const WA_NUMBER_PRETTY = "+91 91676 32596";
